import * as Yup from "yup";

export const PasswordValidation = Yup.string()
  .min(8, "Must be at least 8 characters")
  .max(255)
  .required("Required")
  .matches(/(?=.*[A-Z])/gu, "Must have at least one uppercase")
  .matches(/(?=.*[a-z])/gu, "Must have at least one lowercase")
  .matches(/(?=.*[0-9])/gu, "Must have at least one digit")
  .matches(/(?=.*\W)/gu, "Must have at least one symbol")
  .matches(/^\S*$/gu, "Cannot contain spaces or other whitespace characters");
